// Stable code surfaced as `result.serverError` so the login form can show
// a specific message instead of the generic "Login failed" fallback. Read
// from both server (action-client error mapping) and client (LoginForm), so
// this module is intentionally NOT `server-only`.
export const NO_ORGANIZATION_ERROR_CODE = "AUTH/NO_ORGANIZATION"

export class NoOrganizationError extends Error {
  constructor() {
    super("User has no organization")
    this.name = "NoOrganizationError"
  }
}
